import { useRouter } from "@/app/components/lib/navigation/useRouter";

interface Props {
  shallow?: boolean;
  text: string;
  authLink: { text: string; href: string };
  onClick?: () => void;
}

const AuthRedirectTo: React.FC<Props> = ({ text, authLink, onClick }) => {
  const router = useRouter();
  return (
    <div className="another-auth">
      <span className="auth-text">{text + " "}</span>
      <span
        className="auth-link"
        onClick={!!onClick ? onClick : () => router.push(authLink.href)}
      >
        {authLink.text}
      </span>
    </div>
  );
};

export default AuthRedirectTo;
